<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <product-form :model="product"
                    :resource="resource"
                    :action="action"
                    :canUpdate="canUpdate"
                    :canDelete="canDelete"
                    @created="handleCreated"
                    @updated="handleUpdated"
                    @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import ProductForm from './ProductForm.vue';

export default {
  mixins: [modal, resource],

  components: { ProductForm },

  computed: {
    product() {
      return this.data;
    },
    resource() {
      return 'products';
    },
  },

  methods: {
    handleCreated(product) {
      Event.fire('productCreated', product);
    },
    handleUpdated(product) {
      Event.fire('productUpdated', product);
    },
    handleDeleted(product) {
      Event.fire('productDeleted', product);
    },
  },
};
</script>